import styled from 'styled-components';
import {
  BodyHeavy,
  LoadMoreButton,
  MediaQuery,
  Theme,
} from '@pelando/components';

export const Container = styled.div`
  width: 100%;
`;

export const ListContainer = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;
  padding: 0 16px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  column-gap: 8px;
  margin-left: 0;
  justify-content: center;
  @media ${MediaQuery.SCREEN_LG_UP} {
    justify-content: left;
  }
`;

export const TabsLoadMoreButton = styled(LoadMoreButton)`
  ${BodyHeavy};
  width: 100%;
  margin: 16px 0 16px 0;
  border: 1px solid rgb(${({ theme }) => theme.colors.Golf});
  border-radius: 36px;
  padding: 14px 32px;
  background: rgb(${({ theme }) => theme.colors.Juliet});
  i {
    color: rgb(${Theme.colors.Brand});
    font-size: 24px;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: fit-content;
    margin: 16px auto 16px auto;
  }
`;
